import React, {useState, useEffect} from 'react'
import classNames from 'classnames'

import {
	Text,
	Textarea
} from '../components/form-components'

import {
	isValidMailAddress,
	removeNonNumericCharacters
} from '../utils/util'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc.js'
import timezone from 'dayjs/plugin/timezone.js'
import { createRoot } from 'react-dom/client'
dayjs.extend(utc)
dayjs.extend(timezone)

document.addEventListener('DOMContentLoaded', () => {
	createRoot(document.getElementById('container')!).render(<div id="mb-club-contact"><Contact /></div>)
})

function Contact(){
	const mbClubMemberIdState = useState('')
	const nameState = useState('')
	const mailAddressState = useState('')
	const confirmMailAddressState = useState('')
	const contentState = useState('')
	const [sending, setSending] = useState(false)
	const [sent, setSent] = useState(false)
	const [sendingFailed, setSendingFailed] = useState(false)
	const [validate, setValidate] = useState(false)
	const [nonce, setNonce] = useState<any>(null)

	const dateState = useDate()

	useEffect(() => {
		setNonce(JSON.parse(document.getElementById('nonce')?.dataset.nonce!))
	}, [])


	const validators = {
		mbClubMemberId: v => v.length === 7 || v.length === 0,
		name: v => v.length > 0,
		mailAddress: isValidMailAddress,
		confirmMailAddress: v => v === mailAddressState[0],
		content: v => v.length > 0
	}

	const send = async () => {
		const valid = [
			validators.mbClubMemberId(mbClubMemberIdState[0]),
			validators.name(nameState[0]),
			validators.mailAddress(mailAddressState[0]),
			validators.confirmMailAddress(confirmMailAddressState[0]),
			validators.content(contentState[0])
		].every(v => v)
		if(!valid){
			setValidate(true)
			return
		}
		setSending(true)
		const body = {
			mb_club_member_id: mbClubMemberIdState[0],
			name: nameState[0],
			birthdate: dayjs(dateState.dateObject).tz('Asia/Tokyo').format('YYYY-MM-DD'),
			mail_address: mailAddressState[0],
			content: contentState[0]
		}
		const res = await fetch('/api/mb_club_contacts', {
			method: 'POST',
			credentials: 'include',
			body: JSON.stringify({
				data: body,
				nonce: nonce?.create_mb_club_contact!
			})
		}).then(res => res.json())
		if(res.errors){
			setSendingFailed(true)
		} else {
			setSent(true)
		}
		setSending(false)
	}
	if(sent){
		return <>
			<h3 className="send-complete">送信完了</h3>
		</>
	} else {
		return <>
			<div id="entry">
				<h3>MBクラブに関するご連絡、お問い合わせ</h3>
				<Text name="mb-club-member-id" state={mbClubMemberIdState} className={classNames({invalid: validate && !validators.mbClubMemberId(mbClubMemberIdState[0])})}><p className="label">MBクラブ会員番号</p></Text>
				<p className="input-notes">会員番号がわからない場合は空欄にする</p>
				<Text name="name" state={nameState} className={classNames({invalid: validate && !validators.name(nameState[0])})}><p className="label">氏名</p></Text>
				<div className="input-container">
					<p className="label">生年月日</p>
					<div className={classNames('date-input-container', {invalid: validate && !dateState.valid})}>
						<label>
							<input type="text" name="birth-year" onChange={e => dateState.setYear(e.target.value)} onBlur={e => dateState.replaceYear()} value={dateState.year} />
							年
						</label>
						<label>
							<input type="text" name="birth-month" onChange={e => dateState.setMonth(e.target.value)} onBlur={e => dateState.replaceMonth()} value={dateState.month} />
							月
						</label>
						<label>
							<input type="text" name="birth-date" onChange={e => dateState.setDate(e.target.value)} onBlur={e => dateState.replaceDate()} value={dateState.date} />
							日
						</label>
					</div>
				</div>
				<Text name="email" state={mailAddressState} className={classNames({invalid: validate && !validators.mailAddress(mailAddressState[0])})}><p className="label">メールアドレス</p></Text>
				<p className="input-notes">*申し込み完了後に受付完了の確認メールを送信します。@docomo.ne.jpや@softbank.ne.jp、@ezweb.ne.jp等のキャリアメールは受信拒否設定により受信出来ない場合がございますのでご注意ください。</p>
				<Text name="email-confirm" state={confirmMailAddressState} className={classNames({invalid: validate && !validators.confirmMailAddress(confirmMailAddressState[0])})}><p className="label">メールアドレス(確認)</p></Text>
				<Textarea name="content" state={contentState} className={classNames({invalid: validate && !validators.content(contentState[0])})}><p className="label">連絡内容</p></Textarea>
				<div className="input-container">
					{validate && <p className="entry-form-text">未入力または無効な項目があります</p>}
				</div>
				<button onClick={send} disabled={sending} className="button send-button">送信</button>
				{sendingFailed && <p>送信失敗</p>}
			</div>
		</>
	}
}

function useDate(defaultYear?:number, defaultMonth?:number, defaultDate?:number){
	const [year, setYear] = useState(defaultYear)
	const [month, setMonth] = useState(defaultMonth)
	const [date, setDate] = useState(defaultDate)

	const dateObject = new Date(0, 0, 1, 0, 0, 0)
	dateObject.setFullYear(Number(year))
	dateObject.setMonth(Number(month) - 1)
	dateObject.setDate(Number(date))

	return {
		setYear: y => setYear(y),
		setMonth: m => setMonth(m),
		setDate: d => setDate(d),
		year,
		month,
		date,
		dateObject,
		valid: !Number.isNaN(dateObject.getTime()) && dateObject.getFullYear() === Number(year) && dateObject.getMonth() === Number(month) - 1 && dateObject.getDate() === Number(date),
		replaceYear: () => setYear(Number(removeNonNumericCharacters(year))),
		replaceMonth: () => setMonth(Number(removeNonNumericCharacters(month))),
		replaceDate: () => setDate(Number(removeNonNumericCharacters(date)))
	}
}
